import { ForecastByRoomTypeReportRequestModel } from '../api/models/ForecastByRoomTypeReportRequestModel';
import { ForecastByRoomTypeReportFormModel } from '../models';

export const dataFormToRequest = (
  data: ForecastByRoomTypeReportFormModel
): ForecastByRoomTypeReportRequestModel => {
  return {
    from: data.from,
    to: data.to,
    currency_id: data.currency ? Number(data.currency.id) : null,
    fixed_at: data?.fixed_at ? Number(data?.fixed_at) : null,
    rate_ids: (data?.rates || []).map(item => Number(item)),
    room_type_ids: data?.roomTypeIds,
    card_id: data?.company?.id || null,
    ...(['allocation', 'garantie'].includes(data?.sub_filter) && { type: data?.sub_filter }),
    currency_application: data?.currency_application,
    gross_revenue: data?.gross_revenue,
    with_revenue: data?.with_revenue,
    sub_filter: data?.sub_filter,
    file_type: data?.file_type,
    columns: data.columns,
  };
};
